import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

interface LogoProps {
  collapsed: boolean;
}

export const Logo = ({ collapsed }: LogoProps) => {
  const [envSuffix, setEnvSuffix] = useState("");

  useEffect(() => {
    const hostname = window.location.hostname;

    if (hostname === "localhost" || hostname.includes("127.0.0.1"))
      setEnvSuffix(" (local)");
    else if (hostname === "test.digger.hr")
      setEnvSuffix(" (test)");
    else if (hostname === "mvp.digger.hr")
      setEnvSuffix(" (dev)");
  }, []);

  return (
    <Link to="/" className="group flex items-center px-4 py-3.5">
      {collapsed ? (
        <div className="w-10 h-10 rounded-sm flex items-center justify-center overflow-hidden">
          <img src="/img/NewDiggerIcon.png" alt="Digger" className="w-full h-full object-contain" />
        </div>
      ) : (
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-sm flex items-center justify-center overflow-hidden">
            <img src="/img/NewDiggerIcon.png" alt="Digger" className="w-full h-full object-contain" />
          </div>
          <div className="flex items-baseline gap-0.5">
            <span className="text-xl font-black tracking-tight text-foreground">
              digger
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#5a7ebf] inline-block transition-transform duration-200 group-hover:scale-150" />
            {envSuffix && (
              <span className="text-xs font-medium text-muted-foreground ml-1">
                {envSuffix}
              </span>
            )}
          </div>
        </div>
      )}
    </Link>
  );
};
